import React from 'react';
import { Box, Typography } from '@mui/material';
import { VideoItem } from './VideoCarouselModal';

const MAX_VISIBLE_THUMBNAILS = 5;

interface VideoCarouselThumbnailStripProps {
  videos: VideoItem[];
}

export function VideoCarouselThumbnailStrip({ videos }: VideoCarouselThumbnailStripProps) {
  const overflowCount = videos.length - MAX_VISIBLE_THUMBNAILS;

  return (
    <Box sx={{ display: 'flex', gap: 1, overflowX: 'auto' }}>
      {videos.slice(0, MAX_VISIBLE_THUMBNAILS).map((video) => (
        <Box
          key={video.id}
          component="img"
          src={video.thumbnail}
          alt={video.title}
          sx={{
            width: 80,
            height: 45,
            objectFit: 'cover',
            borderRadius: 1,
          }}
        />
      ))}
      {overflowCount > 0 && (
        <Box
          sx={{
            width: 80,
            height: 45,
            borderRadius: 1,
            bgcolor: 'grey.200',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography variant="caption" color="text.secondary">
            +{overflowCount}
          </Typography>
        </Box>
      )}
    </Box>
  );
}
